import type { Contract } from "@/components/Contracts/contract.interface";
import { ContractsService } from "@/core/libs/api";
import type { FetchResponse } from "@/core/libs/api/utils/fetchData";

export async function getContract(
  contractId: number | string
): Promise<FetchResponse<Contract>> {
  const abortController = new AbortController();
  const { signal } = abortController;

  const service = ContractsService();

  return service.get({
    id: contractId.toString(),
    signal
  }) as Promise<FetchResponse<Contract>>;
}
